import React from 'react';
import { CreditCard, Calendar, Briefcase, Users, TrendingUp, Award, Bell, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
export function Dashboard() {
  const {
    user
  } = useAuth();
  const navigate = useNavigate();
  const stats = [{
    label: 'Status Keanggotaan',
    value: user?.statusKeanggotaan || 'Active',
    icon: Award,
    color: 'text-success',
    bgColor: 'bg-success-light'
  }, {
    label: 'Acara Mendatang',
    value: '3',
    icon: Calendar,
    color: 'text-atios-primary',
    bgColor: 'bg-atios-light'
  }, {
    label: 'Lowongan Baru',
    value: '12',
    icon: Briefcase,
    color: 'text-warning',
    bgColor: 'bg-warning-light'
  }, {
    label: 'Anggota Chapter',
    value: '245',
    icon: Users,
    color: 'text-neutral-700',
    bgColor: 'bg-neutral-100'
  }];
  const upcomingEvents = [{
    title: 'Workshop React Advanced',
    date: '18 Jan 2025',
    time: '14:00 WIB',
    location: 'Online',
    registered: true
  }, {
    title: 'Seminar AI & Machine Learning',
    date: '25 Jan 2025',
    time: '10:00 WIB',
    location: 'Jakarta',
    registered: false
  }, {
    title: 'Meetup Developer Jakarta',
    date: '2 Feb 2025',
    time: '15:00 WIB',
    location: 'Jakarta',
    registered: true
  }];
  const recentJobs = [{
    title: 'Senior Backend Developer',
    company: 'PT Tech Indonesia',
    location: 'Jakarta',
    type: 'Full-time',
    salary: 'Rp 15-20 juta',
    posted: '2 hari lalu'
  }, {
    title: 'Frontend Developer',
    company: 'Startup Digital',
    location: 'Remote',
    type: 'Full-time',
    salary: 'Rp 10-15 juta',
    posted: '3 hari lalu'
  }];
  return <div className="min-h-screen bg-white" data-id="element-2296">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8" data-id="element-2297">
        {/* Header */}
        <div data-id="element-2298">
          <h1 className="text-xl sm:text-2xl lg:text-3xl font-semibold text-neutral-900 mb-2" data-id="element-2299">
            Selamat Datang, {user?.nama}!
          </h1>
          <p className="text-sm sm:text-base text-neutral-600" data-id="element-2300">
            Nomor Anggota:{' '}
            <span className="font-medium text-atios-primary" data-id="element-2301">
              {user?.nomorAnggota}
            </span>
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6" data-id="element-2302">
          {stats.map((stat, i) => <Card key={i} data-id="element-2303">
              <CardContent className="p-4 sm:p-6" data-id="element-2304">
                <div className="flex items-center justify-between mb-3 sm:mb-4" data-id="element-2305">
                  <div className={`p-2 sm:p-3 rounded-lg ${stat.bgColor}`} data-id="element-2306">
                    <stat.icon className={`w-5 h-5 sm:w-6 sm:h-6 ${stat.color}`} data-id="element-2307" />
                  </div>
                  <TrendingUp className="w-4 h-4 text-success" data-id="element-2308" />
                </div>
                <h3 className="text-xl sm:text-2xl font-semibold text-neutral-900 mb-1" data-id="element-2309">
                  {stat.value}
                </h3>
                <p className="text-xs sm:text-sm text-neutral-600" data-id="element-2310">
                  {stat.label}
                </p>
              </CardContent>
            </Card>)}
        </div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8" data-id="element-2311">
          {/* Upcoming Events */}
          <Card data-id="element-2312">
            <CardHeader className="flex flex-row items-center justify-between" data-id="element-2313">
              <CardTitle className="text-base sm:text-lg" data-id="element-2314">
                Acara Mendatang
              </CardTitle>
              <Link to="/events" data-id="element-2315">
                <Button variant="link" className="text-atios-primary text-sm" data-id="element-2316">
                  Lihat Semua
                </Button>
              </Link>
            </CardHeader>
            <CardContent data-id="element-2317">
              <div className="space-y-3 sm:space-y-4" data-id="element-2318">
                {upcomingEvents.map((event, i) => <div key={i} className="flex items-start justify-between p-3 sm:p-4 rounded-lg border border-neutral-200 hover:border-atios-primary transition-all" data-id="element-2319">
                    <div className="flex-1" data-id="element-2320">
                      <div className="flex items-center gap-2 mb-1" data-id="element-2321">
                        <h4 className="font-medium text-sm sm:text-base text-neutral-900" data-id="element-2322">
                          {event.title}
                        </h4>
                        {event.registered && <Badge variant="success" className="text-xs" data-id="element-2323">
                            Terdaftar
                          </Badge>}
                      </div>
                      <p className="text-xs sm:text-sm text-neutral-600 mb-2" data-id="element-2324">
                        {event.date} • {event.time}
                      </p>
                      <p className="text-xs text-neutral-500" data-id="element-2325">
                        {event.location}
                      </p>
                    </div>
                    <Button size="sm" variant={event.registered ? 'secondary' : 'default'} onClick={() => navigate(event.registered ? `/events/${i + 1}` : `/events/${i + 1}/register`)} className="text-xs" data-id="element-2326">
                      {event.registered ? 'Detail' : 'Daftar'}
                    </Button>
                  </div>)}
              </div>
            </CardContent>
          </Card>

          {/* Recent Jobs */}
          <Card data-id="element-2327">
            <CardHeader className="flex flex-row items-center justify-between" data-id="element-2328">
              <CardTitle className="text-base sm:text-lg" data-id="element-2329">
                Lowongan Terbaru
              </CardTitle>
              <Link to="/jobs" data-id="element-2330">
                <Button variant="link" className="text-atios-primary text-sm" data-id="element-2331">
                  Lihat Semua
                </Button>
              </Link>
            </CardHeader>
            <CardContent data-id="element-2332">
              <div className="space-y-3 sm:space-y-4" data-id="element-2333">
                {recentJobs.map((job, i) => <div key={i} className="p-3 sm:p-4 rounded-lg border border-neutral-200 hover:border-atios-primary transition-all" data-id="element-2334">
                    <div className="flex items-start justify-between gap-2 mb-2" data-id="element-2335">
                      <div className="flex-1" data-id="element-2336">
                        <h4 className="font-medium text-sm sm:text-base text-neutral-900 mb-1" data-id="element-2337">
                          {job.title}
                        </h4>
                        <p className="text-xs sm:text-sm text-neutral-600 mb-2" data-id="element-2338">
                          {job.company}
                        </p>
                      </div>
                      <Badge variant="default" className="text-xs flex-shrink-0" data-id="element-2339">
                        {job.type}
                      </Badge>
                    </div>
                    <div className="flex items-center justify-between text-xs sm:text-sm" data-id="element-2340">
                      <div className="text-neutral-600" data-id="element-2341">
                        <p data-id="element-2342">
                          {job.location} • {job.salary}
                        </p>
                        <p className="text-xs text-neutral-500 mt-1" data-id="element-2343">
                          {job.posted}
                        </p>
                      </div>
                      <Button size="sm" variant="secondary" onClick={() => navigate(`/jobs/${i + 1}`)} className="text-xs" data-id="element-2344">
                        Lihat
                      </Button>
                    </div>
                  </div>)}
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Quick Actions */}
        <Card data-id="element-2345">
          <CardHeader data-id="element-2346">
            <CardTitle className="text-base sm:text-lg" data-id="element-2347">Aksi Cepat</CardTitle>
          </CardHeader>
          <CardContent data-id="element-2348">
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4" data-id="element-2349">
              <Link to="/payment" data-id="element-2350">
                <Button variant="secondary" className="w-full h-auto py-3 sm:py-4 flex flex-col gap-2 hover:border-atios-primary transition-all" data-id="element-2351">
                  <CreditCard className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-2352" />
                  <span className="text-xs sm:text-sm" data-id="element-2353">Bayar Iuran</span>
                </Button>
              </Link>
              <Link to="/events" data-id="element-2354">
                <Button variant="secondary" className="w-full h-auto py-3 sm:py-4 flex flex-col gap-2 hover:border-atios-primary transition-all" data-id="element-2355">
                  <Calendar className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-2356" />
                  <span className="text-xs sm:text-sm" data-id="element-2357">Daftar Acara</span>
                </Button>
              </Link>
              <Link to="/jobs" data-id="element-2358">
                <Button variant="secondary" className="w-full h-auto py-3 sm:py-4 flex flex-col gap-2 hover:border-atios-primary transition-all" data-id="element-2359">
                  <Briefcase className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-2360" />
                  <span className="text-xs sm:text-sm" data-id="element-2361">Cari Lowongan</span>
                </Button>
              </Link>
              <Link to="/chapter" data-id="element-2362">
                <Button variant="secondary" className="w-full h-auto py-3 sm:py-4 flex flex-col gap-2 hover:border-atios-primary transition-all" data-id="element-2363">
                  <Users className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-2364" />
                  <span className="text-xs sm:text-sm" data-id="element-2365">Gabung Chapter</span>
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>

        {/* Announcements */}
        <Card data-id="element-2366">
          <CardHeader className="flex flex-row items-center justify-between" data-id="element-2367">
            <CardTitle className="flex items-center gap-2 text-base sm:text-lg" data-id="element-2368">
              <Bell className="w-4 h-4 sm:w-5 sm:h-5 text-atios-primary" data-id="element-2369" />
              Pengumuman Terbaru
            </CardTitle>
            <Link to="/announcements" data-id="element-2370">
              <Button variant="link" className="text-atios-primary text-sm" data-id="element-2371">
                Lihat Semua
                <ArrowRight className="w-4 h-4 ml-1" data-id="element-2372" />
              </Button>
            </Link>
          </CardHeader>
          <CardContent data-id="element-2373">
            <div className="space-y-3" data-id="element-2374">
              <div className="p-3 sm:p-4 rounded-lg bg-atios-light border border-atios-primary/20" data-id="element-2375">
                <div className="flex items-start gap-2 sm:gap-3" data-id="element-2376">
                  <Badge variant="primary" className="mt-0.5 text-xs" data-id="element-2377">
                    BARU
                  </Badge>
                  <div className="flex-1" data-id="element-2378">
                    <h4 className="font-medium text-sm sm:text-base text-neutral-900 mb-1" data-id="element-2379">
                      Perpanjangan Keanggotaan 2025
                    </h4>
                    <p className="text-xs sm:text-sm text-neutral-600" data-id="element-2380">
                      Perpanjangan keanggotaan tahun 2025 sudah dibuka. Dapatkan
                      diskon early bird hingga 31 Januari 2025.
                    </p>
                    <p className="text-xs text-neutral-500 mt-2" data-id="element-2381">
                      2 hari yang lalu
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-3 sm:p-4 rounded-lg border border-neutral-200" data-id="element-2382">
                <h4 className="font-medium text-sm sm:text-base text-neutral-900 mb-1" data-id="element-2383">
                  Kongres ATIOS 2025
                </h4>
                <p className="text-xs sm:text-sm text-neutral-600" data-id="element-2384">
                  Save the date! Kongres ATIOS 2025 akan diselenggarakan pada
                  15-17 Maret 2025 di Jakarta.
                </p>
                <p className="text-xs text-neutral-500 mt-2" data-id="element-2385">
                  5 hari yang lalu
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}